import { type KickOffMappedState } from './types';

import { DEFAULT_SECTION } from '@/components/KickOffs/types';
import { type KickOffData } from '@/graphql/generated/graphql';
import { DEFAULT_ADDRESS } from '@/utils/constants';

export const mapKickOffToState = (data: KickOffData): KickOffMappedState => {
  return {
    project: {
      id: data?.projectId ?? '0',
      title: data?.projectTitle ?? '',
      code: data?.projectCode ?? '',
    },
    client: {
      id: data?.clientId ?? null,
      name: data?.clientName ?? null,
      companyNumber: data?.clientCompanyNumber ?? null,
      reps: data?.clientReps ?? [],
    },
    basics: {
      addresses: data?.addresses?.length ? data.addresses : [DEFAULT_ADDRESS],
    },
    details: {
      managers: data?.projectDetails?.managers ?? [],
      activities: data?.projectDetails?.activities ?? [],
      settings: data?.projectDetails?.projectSettings ?? [],
      contractTypeIds: data?.projectDetails?.contractTypeIds ?? [],
      tagIds: data?.projectDetails?.projectTagIds ?? [],
    },
    notes: data?.notes?.length ? data?.notes : [DEFAULT_SECTION],
    template: {
      newTemplate: data?.newTemplate ?? false,
      title: data?.newTemplateTitle ?? '',
    },
  };
};
